export const FileDownloadHelper = {
  base64ToArrayBuffer (base64) {
    const binaryString = window.atob(base64)
    const len = binaryString.length
    const bytes = new Uint8Array(len)
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i)
    }
    return bytes
  },

  isBase64 (data) {
    if (typeof data !== 'string') return false
    try {
      return btoa(atob(data)) === data
    } catch (err) {
      return false
    }
  },

  downloadFile (data, filename, mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
    let blob

    if (data instanceof Blob) {
      blob = data
    } else if (this.isBase64(data)) {
      const arrayBuffer = this.base64ToArrayBuffer(data)
      blob = new Blob([arrayBuffer], { type: mimeType })
    } else if (typeof data === 'string') {
      const arrayBuffer = this.base64ToArrayBuffer(data)
      blob = new Blob([arrayBuffer], { type: mimeType })
    } else {
      blob = new Blob([data], { type: mimeType })
    }

    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', filename)
    link.style.display = 'none'
    document.body.appendChild(link)
    link.click()

    window.URL.revokeObjectURL(url)
    document.body.removeChild(link)
  },

  generateTimestampFilename (baseName, extension = 'xlsx') {
    const now = new Date()
    const year = now.getFullYear()
    const month = String(now.getMonth() + 1).padStart(2, '0')
    const day = String(now.getDate()).padStart(2, '0')
    const hours = String(now.getHours()).padStart(2, '0')
    const minutes = String(now.getMinutes()).padStart(2, '0')
    const seconds = String(now.getSeconds()).padStart(2, '0')

    return `${baseName}_${year}${month}${day}_${hours}${minutes}${seconds}.${extension}`
  }
}



// WEBPACK FOOTER //
// ./src/shared/utils/FileDownloadHelper.js